import { useAuth } from 'auth/hooks/useAuth';
import { useSecurity } from 'auth/hooks/useSecurity';
import { LoginPhase } from 'navigation/models/login-phase';
import { useEffect } from 'react';
import { LoginFooter, LoginForm, LoginInfo } from './components';

import {
  LoginFormContainer,
  LoginPageContainer,
  LoginTopContainer,
} from './LoginPage.styles';

export function LoginPage() {
  const { login, user, disableSignIn } = useAuth();
  const { saveLoginPhase } = useSecurity();

  const onSubmit = ({ username, password }) => {
    login(username, password);
  };

  useEffect(() => {
    if (!user) {
      saveLoginPhase(LoginPhase.LOGIN);
    }
  }, [user, saveLoginPhase]);

  return (
    <LoginPageContainer>
      <LoginTopContainer>
        <LoginInfo />
        <LoginFormContainer>
          <LoginForm onSubmit={onSubmit} disableSignIn={disableSignIn} />
        </LoginFormContainer>
      </LoginTopContainer>
      <LoginFooter />
    </LoginPageContainer>
  );
}
